export default (to, from, next) => {
    if (sessionStorage.getItem('connectedAccount') != null && sessionStorage.getItem('connectedAccount').length > 0) {
        // verify with firebase or jwt
        next()
    } else {
        sessionStorage.removeItem('connectedAccount')
        next('/login')
            // next()
    }
}